module.exports = __webpack_public_path__ + "static/media/card3_1.b50335b2.png";